type State = {
	address: string
	country: string;
	state: string;
	city: string;
	zip: string;
}

type Action =
| { type: 'address', address: string }
| { type: 'country', country: string }
| { type: 'city', city: string }
| { type: 'state', state: string }
| { type: 'zip', zip: string}

export default function locationReducer(state: State, action: Action): State {
	switch (action.type) {
	case 'address':
		return {...state, address: action.address }
	case 'country':
		return { ...state, country: action.country }
	case 'city':
		return { ...state, city: action.city }
	case 'state':
		return {...state, state: action.state }
	case 'zip':
		return {...state, zip: action.zip }
	}
}
